/**
 * @flow
 * @relayHash f503362c4d7124d74b984414a93510fa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ItemEventsShownInput = {|
  userId: string,
  clientMutationId?: ?string,
|};
export type itemEventsShownMutationVariables = {|
  input: ItemEventsShownInput
|};
export type itemEventsShownMutationResponse = {|
  +itemEventsShown: ?{|
    +favoriteNotifications: ?{|
      +hasNewEvents: ?boolean
    |}
  |}
|};
export type itemEventsShownMutation = {|
  variables: itemEventsShownMutationVariables,
  response: itemEventsShownMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ItemEventsShownInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "ItemEventsShownInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasNewEvents",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "itemEventsShownMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "itemEventsShown",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ItemEventsShownPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "favoriteNotifications",
            "storageKey": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "itemEventsShownMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "itemEventsShown",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ItemEventsShownPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "favoriteNotifications",
            "storageKey": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "itemEventsShownMutation",
    "id": "dibs-buyer-layout/209.2.8-2019-03-25T20:56:18.750Z/itemEventsShownMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1282ef6d92da32b74264cdd1393e3f71';
module.exports = node;
